/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbarsection from '../views/Home/Navbarsection';
import Footersection from '../views/Home/Footersection';

const services = [
  { 
    title: "Kids & Child WellBeing", 
    img: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/Child%20WellBeing.png?updatedAt=1708320334991",
    content: "Providing essential resources, nutrition, and early childhood support to ensure every child has a healthy start and a bright future."
  },
  { 
    title: "Mother Welfare", 
    img: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/Mother%20Encouragement.png?updatedAt=1708320334087",
    content: "Empowering mothers through counseling, health awareness, and vocational training to build strong, self-reliant families."
  },
  { 
    title: "Education Welfare", 
    img: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/Education%20Encouragement.png?updatedAt=1708320334298",
    content: "Breaking barriers to education by providing scholarships, school supplies, and mentoring programs for underprivileged students."
  },
  { 
    title: "Youngsters Success", 
    img: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/Young%20Generation%20Success.png?updatedAt=1708320326758",
    content: "Guiding the youth with career counseling and skill development workshops to prepare them for the modern professional world."
  },
  { 
    title: "Feeding For Life", 
    img: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/Feeding%20around%20For%20Life.png?updatedAt=1708320328289",
    content: "Running community kitchens and food distribution drives to combat hunger and ensure no one goes to bed on an empty stomach."
  },
  { 
    title: "Business For Small Sector", 
    img: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/Business%20For%20Small%20Sector.png?updatedAt=1708320327237",
    content: "Supporting local entrepreneurs and small businesses with micro-loans and strategic guidance to boost community economies."
  },
  { 
    title: "Social Support For Growth", 
    img: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/Soical%20Support%20For%20Growth.png?updatedAt=1708321114901",
    content: "Creating a network of social security through community advocacy and legal aid for those in vulnerable situations."
  },
  { 
    title: "Healthcare For Life", 
    img: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/OTHERS/Healthcare%20around%20for%20Life.png?updatedAt=1708321114076",
    content: "Improving access to quality medical care, mobile health clinics, and emergency health support for remote communities."
  },
];

export default function Our_services_hickter() {
  const [selectedId, setSelectedId] = useState(null);

  return (
    <div className="min-h-screen bg-[#FFF9F5] overflow-x-hidden">
 
      {/* Hero Header */}
      <section className="bg-orange-600 py-16 md:py-24 px-6 relative overflow-hidden">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-7xl mx-auto text-center relative z-10"
        >
          <h1 className="text-white text-5xl md:text-8xl font-black mb-4 tracking-tight">
            WHAT WE DO
          </h1>
          <div className="h-1.5 w-24 bg-orange-400 mx-auto mb-6 rounded-full"></div>
          <p className="text-orange-100 text-lg md:text-xl max-w-3xl mx-auto font-medium">
            Building a stronger society through direct action and community empowerment.
          </p>
        </motion.div>
      </section>

      {/* Grid Section */}
      <section className="py-12 md:py-20 px-4 md:px-12">
        <div className="max-w-[1920px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
            {services.map((service, index) => (
              <motion.div
                key={index}
                layoutId={`card-${index}`}
                onClick={() => setSelectedId(index)}
                className="cursor-pointer group relative"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <div className="relative h-[400px] md:h-[550px] rounded-[2.5rem] overflow-hidden shadow-2xl transition-all duration-500">
                  <img 
                    src={service.img} 
                    alt={service.title} 
                    className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                  />
                  
                  {/* Blackish Orange Blur Title Bar */}
                  <div className="absolute bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-6">
                    <div className="bg-orange-950/40 backdrop-blur-xl border border-white/10 p-4 md:p-6 rounded-3xl transition-all duration-500 group-hover:bg-orange-600/60">
                      <h3 className="text-white text-lg md:text-2xl font-black leading-tight uppercase">
                        {service.title}
                      </h3>
                      <div className="mt-2 flex items-center gap-2 text-orange-300 font-bold text-[10px] md:text-xs tracking-widest">
                        EXPLORE <span className="text-base group-hover:translate-x-1 transition-transform">→</span>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Compact Modal View */}
      <AnimatePresence>
        {selectedId !== null && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSelectedId(null)}
              className="absolute inset-0 bg-orange-950/80 backdrop-blur-sm"
            />
            
            <motion.div 
              layoutId={`card-${selectedId}`}
              className="relative bg-white w-full max-w-4xl rounded-[2rem] md:rounded-[3rem] overflow-hidden shadow-2xl flex flex-col md:flex-row max-h-[90vh]"
            >
              <button 
                onClick={() => setSelectedId(null)}
                className="absolute top-4 right-4 z-20 bg-orange-600 text-white w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center text-sm md:text-base font-bold shadow-lg"
              >
                ✕
              </button>

              {/* Modal Image - Optimized size */}
              <div className="w-full md:w-[45%] h-[200px] md:h-auto">
                <img 
                  src={services[selectedId].img} 
                  className="w-full h-full object-cover" 
                  alt={services[selectedId].title} 
                />
              </div>

              {/* Modal Content - Smaller Padding */}
              <div className="w-full md:w-[55%] p-6 md:p-10 flex flex-col justify-center bg-white overflow-y-auto">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-6 h-[2px] bg-orange-500"></span>
                  <span className="text-orange-600 font-bold tracking-widest uppercase text-[10px] md:text-xs">
                    Overview
                  </span>
                </div>
                
                <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-4 leading-tight uppercase">
                  {services[selectedId].title}
                </h2>
                
                <p className="text-gray-500 text-sm md:text-base leading-relaxed mb-6 font-medium">
                  {services[selectedId].content}
                </p>

                <button 
                  onClick={() => setSelectedId(null)}
                  className="bg-gray-900 text-white px-6 py-3 rounded-xl text-xs md:text-sm font-black hover:bg-orange-600 transition-all w-fit"
                >
                  RETURN TO SERVICES
                </button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

     </div>
  );
}